<app-header></app-header>
<!-- <app-top-header></app-top-header> -->
<div class="content-bg">
    <div fxLayout="column" fxLayoutAlign="center center" class="h-700">
        <h1 class="ff error-code">404</h1>
        <h1 class="ff">Oops! This page could not be found!</h1>
        <a [routerLink]="homeUrl" class="pointer heading"><i class="fa fa-home text-info  pr-5 fs-16" aria-hidden="true"></i>GO TO HOME</a>
    </div>
</div>
<app-website-footer></app-website-footer>
<!-- <app-footer></app-footer> -->